import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rdsRemoveChipLabel',
})
export class RdsRemoveChipLabelPipe implements PipeTransform {
  transform(value?: string | null): string {
    const _value = value || '';
    return $localize`Remove ${_value}`;
  }
}

@NgModule({
  declarations: [RdsRemoveChipLabelPipe],
  exports: [RdsRemoveChipLabelPipe],
})
export class RdsRemoveChipLabelPipeModule {}
